import { LayoutNoAuth } from 'app/components/templates/LayoutNoAuth';
import { Stack, styled, Typography } from '@mui/material';
import { ButtonCustom, ButtonNoOutLine } from 'app/components/elements/ButtonCustom';
import { StyledParams } from 'types/common';
import { useInjection } from './hook';
import { useSystemInfo } from 'contexts/systemInfo';

export const ForgotPasswordSuccessPage = () => {
  const { systemInfo } = useSystemInfo();
  const { handleResetLink, navigateLogin } = useInjection();
  return (
    <LayoutNoAuth>
      <Wrapper>
        <Stack pt={8.375} pb={3.5} width={'100%'} alignItems={'center'} minHeight={'100vh'}>
          <Stack
            px={{ xs: 3.125, sm: 0 }}
            mt={3}
            width={'100%'}
            maxWidth={{ xs: 'unset', sm: 402 }}>
            <Stack width={'100%'} alignItems={'center'} gap={7.25} mb={33.75}>
              {systemInfo?.logoUrl && <img alt={'logo'} width={96} src={systemInfo?.logoUrl} />}
              <Stack gap={2}>
                <TextTitleStyled>Forgot Password</TextTitleStyled>
                <TextDescStyled>
                  You will receive an email shortly with a link to reset your password.
                </TextDescStyled>
              </Stack>
            </Stack>
            <Stack gap={3.25}>
              <ButtonCustom onClick={navigateLogin} label={'Back to Login'} />
              <ButtonNoOutLine onClick={handleResetLink} label={'Resend Link'} />
            </Stack>
          </Stack>
        </Stack>
      </Wrapper>
    </LayoutNoAuth>
  );
};
const Wrapper = styled(Stack)(() => ({
  height: '100vh',
  overflowY: 'scroll'
}));
const TextTitleStyled = styled(Typography)(({ theme }: StyledParams) => ({
  fontSize: '32px',
  fontWeight: '700',
  color: theme.colors.base,
  textAlign: 'center'
}));
const TextDescStyled = styled(Typography)(({ theme }: StyledParams) => ({
  fontSize: '14px',
  fontWeight: '700',
  color: theme.colors.base,
  textAlign: 'center',
  width: 271
}));
